// src/firebase.js
import { initializeApp, getApps, getApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getDatabase } from 'firebase/database'

const firebaseConfig = {
  apiKey: 'AIzaSyBuk4aTfdhx3ZY4xxyyHaI97EXAl7kROYQ',
  authDomain: 'event-matching-afd49.firebaseapp.com',
  projectId: 'event-matching-afd49',
  storageBucket: 'event-matching-afd49.appspot.com',
  messagingSenderId: '868114325367',
  appId: '1:868114325367:web:f393d3db8c2004349f0b72',
  measurementId: 'G-FX002F07T0',
  databaseURL:
    'https://event-matching-afd49-default-rtdb.asia-southeast1.firebasedatabase.app/'
}

export const firebaseApp = getApps().length
  ? getApp()
  : initializeApp(firebaseConfig)
export const auth = getAuth(firebaseApp)
export const database = getDatabase(firebaseApp)

let secondaryAuthInstance = null

export function getSecondaryAuth() {
  if (secondaryAuthInstance) return secondaryAuthInstance

  const existingApp = getApps().find((app) => app.name === 'secondary')
  const secondaryApp = existingApp || initializeApp(firebaseConfig, 'secondary')
  secondaryAuthInstance = getAuth(secondaryApp)
  return secondaryAuthInstance
}
